export default "__VITE_ASSET__a6be3626__"